import isStartupDataEnabled from 'bootstrap/lib/isStartupDataEnabled';
import setUserConfiguration from 'owa-session-store/lib/actions/setUserConfiguration';
import { earlyProcessingForMini } from 'mini-early-processing/lib/earlyProcessingForMini';
import { getMiniAnalyticsOptions } from 'mini-app-analytics';
import { getStartupBootPromise } from 'bootstrap/lib/getStartupBootPromise';
import { handleBootErrorForMini } from 'mini-auth-error-handler/lib/handleBootErrorForMini';
import { isToDoModule } from './isToDoModule';
import { LazyAction, LazyBootModule } from 'owa-bundling-light';
import { OwaWorkload } from 'owa-workloads';
import { ServerAppName } from 'data/lib/mini-app-constants';
import { SessionData } from 'owa-service/lib/types/SessionData';
import { sharedStart } from 'owa-shared-start/lib/sharedStart';
import { triggerFetchForPeople } from './triggerFetchForPeople';
import { triggerFetchForToDo } from 'mini-todo-module-view';
import { updateBaseUrlAndHandleAuthError } from 'mini-auth-error-handler/lib/updateBaseUrlAndHandleAuthError';

const lazyModule = new LazyBootModule(
    () => import(/* webpackChunkName: "PeopleBoot" */ './lazyIndex')
); //this should be first, as it sets cdn url for webpack

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function startPeopleBootstrap() {
    sharedStart({
        app: ServerAppName.MiniPeople,
        startupAriaToken: getMiniAnalyticsOptions().ariaTenantTokens[0],
        overrideBootPromises: isStartupDataEnabled()
            ? getStartupBootPromise(ServerAppName.MiniPeople)
            : null,
        runAfterRequests: async (sessionDataPromise: Promise<SessionData>) => {
            updateBaseUrlAndHandleAuthError(sessionDataPromise);
            triggerFetchForPeople();
            if (isToDoModule()) {
                const sessionData = await sessionDataPromise;
                // We need to clone the user-config because setUserConfiguration mutates the owaUserConfig object by deleting few properties
                const owaUserConfigCopy = JSON.parse(JSON.stringify(sessionData.owaUserConfig));
                setUserConfiguration(owaUserConfigCopy);
                // NOTE: Session data needs to be fetched before the todo tasks can be fetched
                // Because "autodiscover" API needs user's email to know which tasks API to use
                // and the email is not available until the session data is fetched
                triggerFetchForToDo();
            }
            earlyProcessingForMini(OwaWorkload.People, sessionDataPromise);
        },
        bootstrap: new LazyAction(lazyModule, m => m.bootstrapPeopleModule),
        handleBootError: handleBootErrorForMini,
    });
}
